// extracted by mini-css-extract-plugin
export default {"alert":"Message_alert__OWs0A","icon":"Message_icon__olRgD","info":"Message_info__wv0Jn","success":"Message_success__iwtVp","error":"Message_error__Dd2nR"};